var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0117 1.5L7.77362 5.54762H5.22567L1.98758 1.5H11.0117ZM7.51393 7.55714V10.2301L5.48536 10.9063V7.55714H7.51393Z",
    fill: "#2A3140",
    stroke: "#2A3140"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.947266 1H12.052H0.947266Z",
    fill: "#2A3140"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.947266 1H12.052",
    stroke: "#2A3140",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.ccda92fd4a065314ba9cc584d76634a7.svg";
export { ForwardRef as ReactComponent };